import i18n from 'i18next';

export default (model = {}) => ({
  actions: [
    { action: 'cancel', text: i18n.t('cancel'), variant: 'ghost' },
    { action: 'submit', color: 'brand', text: i18n.t('publish') },
  ],
  body: i18n.t('publish-content-body'),
  hasCloseButton: true,
  model,
  title: i18n.t('publish-content'),
});
